import { SliderItem as SliderItemCore } from '@studiometa/ui';
import { lerp } from '@studiometa/js-toolkit/utils';

/**
 * @typedef {object} SliderItemRef
 * @property {HTMLImageElement} img
 * @property {HTMLElement} title
 * @property {HTMLElement} titleInner
 * @property {HTMLElement} surTitle
 * @property {HTMLElement} surTitleInner
 */

/**
 * @typedef {object} SliderItemInterface
 * @property {SliderItemRef} $refs
 */

/**
 * SliderItem class
 */
export default class SliderItem extends SliderItemCore {
  static config = {
    ...SliderItemCore.config,
    name: 'SliderItem',
    emits: ['clicked'],
    options: {
      external: String,
    },
    refs: ['img', 'title', 'titleInner', 'surtitle', 'surtitleInner'],
  };

  /**
   * Emit the clicked event on click
   * @param   {Event} event
   * @this    {SliderItem & SliderItemInterface}
   * @returns {void}
   */
  onClick(event) {
    if (this.$options.external !== 'true') {
      event.preventDefault();
      this.$emit('clicked', this);
    }
  }

  /**
   * Render function
   * @this    {SliderItem & SliderItemInterface}
   * @returns {void}
   */
  render() {
    super.render();
    const x = this.rect.x + this.dampedX;
    const progress = (x - 0.5 * (window.innerWidth - this.$el.clientWidth)) / window.innerWidth;

    this.$refs.img.style.transform = `translate(calc(-50% + ${-25 * progress}vw), -50%)`;
    this.$refs.img.style.opacity = lerp(0.6, 0, 2.5 * Math.abs(progress));

    this.$refs.title.style.opacity = lerp(1, 0.15, 1.25 * Math.abs(progress));
    this.$refs.surtitle.style.opacity = lerp(1, 0.15, 1.25 * Math.abs(progress));
  }
}
